// extracted by mini-css-extract-plugin
export var formContainer = "_i1-0";
export var message = "_i1-1";